import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';

import { EventTypes } from '../types';
import { EventAdapter } from './EventAdapter';

export class DeleteRosterEventAdapter extends EventAdapter {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = function sendEventData() {
    sendTeacherAmplitudeEvent(EventTypes.DeleteRoster);
  };
  constructor() {
    super();
    this.eventData = {};
  }
}
